<div class="grid full-height-grid">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pt-6">
    <div class="grid">
      <div class="col-1"></div>
      <div class="col-8">
        <div class="grid">
          <div class="col-12">
            <h2 class="page-title gap-2 mb-2">
              {{ 'Auth.LogoutSuccessful' | translate }}
            </h2>
            <br />
            <span class="large-paragraph link-message">
              {{ 'Auth.LogoutDescription' | translate }}
            </span>
            <br />
            <p-button [label]="'Common.Login' | translate"
              styleClass="p-button-rounded"
              class="p-2"
              (onClick)="onLoginClicked()" />
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </div>
</div>
